import { render, staticRenderFns } from "./alert-sub.vue?vue&type=template&id=7de937ee&lang=pug&"
import script from "./alert-sub.vue?vue&type=script&lang=js&"
export * from "./alert-sub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports